"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const LogManager_1 = require("../Log/LogManager");
const Entity_1 = require("../Common/Entity");
const FudaoDefinition_1 = require("./FudaoDefinition");
const NullFudaoPassedTimeCounter_1 = require("./Port/NullFudaoPassedTimeCounter");
const NullFudaoRepository_1 = require("./Port/NullFudaoRepository");
const NullCommandHub_1 = require("../Engine/Command/Port/NullCommandHub");
const NullEventHub_1 = require("../Engine/Event/Port/NullEventHub");
const IEventHub_1 = require("../Engine/Event/IEventHub");
const NullFudaoSessionFacade_1 = require("./Port/NullFudaoSessionFacade");
const CommonBaseError_1 = require("../Common/CommonBaseError");
const FudaoUser_1 = require("./FudaoUser");
const FudaoCommand_1 = require("./FudaoCommand");
const FudaoDto_1 = require("./Protocol/FudaoDto");
const FudaoEvent_1 = require("./FudaoEvent");
const RtcCommand_1 = require("../Engine/Command/RtcCommand");
const moment = require("moment");
const TypeScriptUtils_1 = require("../Common/TypeScriptUtils");
//export const DEFAULT_STANDARD_DURATION = 0.5 * 60 * 1000;
//export const DEFAULT_STANDARD_DURATION = 1 * 60 * 1000;
exports.DEFAULT_STANDARD_DURATION = 45 * 60 * 1000; //預設輔導期間目前定義45分鐘
exports.DEFAULT_EXTEND_DURATION = 15 * 60 * 1000; //預設延長期間定義15分鐘
//最大延長輔導次數
const MAX_EXTENDED_TIMES = 1;
class Fudao extends Entity_1.Entity {
    constructor(isService, cmdHub, evtHub, ifr, fptc, ifsf, fudao) {
        super(isService, Fudao.logger, FudaoDefinition_1.FudaoCommandCategory, cmdHub, FudaoDefinition_1.FudaoEventCategory, evtHub);
        this._id = "";
        this._version = Fudao.CurrentVersion;
        this._teacher = FudaoUser_1.FudaoUser.INVALID_FUDAO_USER;
        this._student = FudaoUser_1.FudaoUser.INVALID_FUDAO_USER;
        this._standardDuration = 0;
        this._extendDuration = 0;
        this._startTime = new Date();
        this._endTime = new Date();
        this._status = FudaoDefinition_1.Status.None;
        this._chatId = "";
        this._sessionIds = [];
        this._dataSession = FudaoDefinition_1.FudaoSession.INVALID_FUDAO_SESSION;
        this._extendedTimes = 0;
        this._startInvitingStatus = FudaoDefinition_1.InvitingStatus.None;
        this._endInvitingStatus = FudaoDefinition_1.InvitingStatus.None;
        this._extendInvitingStatus = FudaoDefinition_1.InvitingStatus.None;
        this._sessionInvitingStatus = FudaoDefinition_1.FudaoSessionInvitingStatus.INVAID_FUDAO_INVITING_STATUS;
        this._passedTimeMilliSecond = 0;
        this._localDataProvider = new rxjs_1.Subject();
        this._remoteDataReceiver = new rxjs_1.Subject();
        this._lastSendTimePassedEventTime = 0;
        this._lastReportAliveTime = 0;
        this._fudaoRepo = ifr;
        this._fudaoTimeCounter = fptc,
            this._sessionFacade = ifsf;
        this._status = FudaoDefinition_1.Status.Created;
        this.registerAsyncCommandHandler(FudaoCommand_1.FudaoCommand.TeacherInviteStartFudao, async (rtcCmd) => await this.OnInviteStartCommandAsync(rtcCmd));
        this.registerAsyncCommandHandler(FudaoCommand_1.FudaoCommand.TeacherStartFudao, async (rtcCmd) => await this.OnStartCommandAsync(rtcCmd));
        this.registerAsyncCommandHandler(FudaoCommand_1.FudaoCommand.TeacherInviteExtendFudao, async (rtcCmd) => await this.OnInviteExtendCommandAsync(rtcCmd));
        this.registerAsyncCommandHandler(FudaoCommand_1.FudaoCommand.TeacherExtendFudao, async (rtcCmd) => await this.OnExtendCommandAsync(rtcCmd));
        this.registerAsyncCommandHandler(FudaoCommand_1.FudaoCommand.TeacherInviteEndFudao, async (rtcCmd) => await this.OnInviteEndCommandAsync(rtcCmd));
        this.registerAsyncCommandHandler(FudaoCommand_1.FudaoCommand.TeacherEndFudao, async (rtcCmd) => await this.OnEndCommandAsync(rtcCmd));
        this.registerAsyncCommandHandler(FudaoCommand_1.FudaoCommand.TeacherInviteStartSession, async (rtcCmd) => await this.OnInviteStartSessionCommandAsync(rtcCmd));
        this.registerAsyncCommandHandler(FudaoCommand_1.FudaoCommand.TeacherInviteEndSession, async (rtcCmd) => await this.OnInviteEndSessionCommandAsync(rtcCmd));
        this.registerAsyncEventHandler(FudaoEvent_1.FudaoEvent.FudaoStarted, async (evt) => await this.OnStartEventAsync(evt));
        this.registerAsyncEventHandler(FudaoEvent_1.FudaoEvent.FudaoStartFailed, async (evt) => await this.OnFudaoStartFailed(evt));
        this.registerAsyncEventHandler(FudaoEvent_1.FudaoEvent.TeacherTimePassed, (evt) => this.OnUpdateTimePassedAsync(evt));
        this.registerAsyncEventHandler(FudaoEvent_1.FudaoEvent.FudaoExtended, async (evt) => await this.OnExtendEventAsync(evt));
        this.registerAsyncEventHandler(FudaoEvent_1.FudaoEvent.FudaoEnded, async (evt) => await this.OnEndEventAsync(evt));
        this.registerAsyncEventHandler(FudaoEvent_1.FudaoEvent.StudentStartFudaoSessionReceived, async (evt) => await this.OnStartFudaoSessionEventAsync(evt));
        this.registerAsyncEventHandler(FudaoEvent_1.FudaoEvent.FudaoSessionInited, async (evt) => await this.OnStartFudaoSessionEventAsync(evt));
        this.registerAsyncEventHandler(FudaoEvent_1.FudaoEvent.FudaoSessionStarted, async (evt) => await this.OnStartFudaoSessionEventAsync(evt));
        // RegisterAsyncEventHandler(FudaoEvent.FudaoSessionNetworkQualityChanged, OnSessionNetworkQualityChanged);
        this.registerAsyncEventHandler(FudaoEvent_1.FudaoEvent.FudaoSessionFailed, async (evt) => await this.OnFailFudaoSessionEventAsync(evt));
        this.registerAsyncEventHandler(FudaoEvent_1.FudaoEvent.FudaoSessionEnded, async (evt) => await this.OnEndFudaoSessionEventAsync(evt));
        if (fudao) {
            if (!fudao.id)
                throw new FudaoError(`Invalid id=${fudao.id}`);
            this.id = fudao.id || this.id;
            this._version = fudao.Version || this.Version;
            if (!fudao.Teacher || fudao.Teacher === FudaoUser_1.FudaoUser.INVALID_FUDAO_USER)
                throw new FudaoError(`Invalid teacher=${fudao.Teacher}`);
            this._teacher = fudao.Teacher || this.Teacher;
            if (!fudao.Student || fudao.Student === FudaoUser_1.FudaoUser.INVALID_FUDAO_USER)
                throw new FudaoError(`Invalid student=${fudao.Student}`);
            this._student = fudao.Student || this.Student;
            this._standardDuration = fudao.StandardDuration || exports.DEFAULT_STANDARD_DURATION;
            this._extendDuration = fudao.ExtendDuration || exports.DEFAULT_EXTEND_DURATION;
            this._startTime = fudao.StartTime || this.StartTime;
            this._endTime = fudao.EndTime || this.EndTime;
            this._status = fudao.Status || this.Status;
            if (!fudao.ChatId)
                throw new FudaoError(`Invalid ChatId=${fudao.ChatId}`);
            this._chatId = fudao.ChatId || this.ChatId;
            this._sessionIds = fudao.SessionIds ? fudao.SessionIds.slice() : this._sessionIds;
            this._dataSession = fudao.DataSession || this.DataSession;
            this._extendedTimes = fudao.ExtendedTimes || this.ExtendedTimes;
            this._startInvitingStatus = fudao.StartInvitingStatus || this.StartInvitingStatus;
            this._endInvitingStatus = fudao.EndInvitingStatus || this.EndInvitingStatus;
            this._extendInvitingStatus = fudao.ExtendInvitingStatus || this.ExtendInvitingStatus;
            this._sessionInvitingStatus = fudao.SessionInvitingStatus || this.SessionInvitingStatus;
            this._passedTimeMilliSecond = fudao.PassedTimeMilliSecond || this.PassedTimeMilliSecond;
        }
    }
    set id(value) { this._id = value; }
    get id() { return this._id; }
    //public set version(value: number) { this._version = value; }
    get Version() { return this._version; }
    get Teacher() { return this._teacher; }
    get Student() { return this._student; }
    get StandardDuration() { return this._standardDuration; }
    get ExtendDuration() { return this._extendDuration; }
    get StartTime() { return this._startTime; }
    get EndTime() { return this._endTime; }
    get Status() { return this._status; }
    get ChatId() { return this._chatId; }
    get SessionIds() { return this._sessionIds.slice(); }
    get DataSession() { return this._dataSession; }
    get ExtendedTimes() { return this._extendedTimes; }
    get StartInvitingStatus() { return this._startInvitingStatus; }
    get EndInvitingStatus() { return this._endInvitingStatus; }
    get ExtendInvitingStatus() { return this._extendInvitingStatus; }
    get SessionInvitingStatus() { return this._sessionInvitingStatus; }
    get PassedTimeMilliSecond() { return this._passedTimeMilliSecond; }
    async InviteStartAsync(t, s) {
        if (!t.IsTeacher)
            throw new FudaoError(`${t} is not teacher.`);
        if (this.Status !== FudaoDefinition_1.Status.Created)
            throw new FudaoError(`Wrong status=${FudaoDefinition_1.Status}, it should be ${FudaoDefinition_1.Status.Created}`);
        if (this.StartInvitingStatus === FudaoDefinition_1.InvitingStatus.InvitingSent)
            throw new FudaoError(`StartInvitingStatus=${this.ExtendInvitingStatus} is wrong`);
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            //老師邀請學生開始輔導
            await this.BecomeStartInvitingStatus(FudaoDefinition_1.InvitingStatus.InvitingSent);
            //準備好要連接的Session，透過Command通知對方
            this._dataSession = await this._sessionFacade.RequestToStartSessionAsync(FudaoDefinition_1.FudaoSessionType.Data, t, [s]);
            const fudaoDto = this.ToFudaoDto();
            await this.sendCommandAsync(FudaoCommand_1.FudaoCommand.TeacherInviteStartFudaoCommand(fudaoDto, this.Student));
            await this.publishEventAsync(FudaoEvent_1.FudaoEvent.TeacherStartInvitationSentEvent(fudaoDto), [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    async OnInviteStartCommandAsync(rtcCmd) {
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            switch (rtcCmd.type) {
                case RtcCommand_1.CmdType.RequestExecute:
                    //學生收到邀請是否要接受輔導
                    await this.BecomeStartInvitingStatus(FudaoDefinition_1.InvitingStatus.InvitingSent);
                    await this.publishEventAsync(FudaoEvent_1.FudaoEvent.StudentStartInvitationReceivedEvent(this.ToFudaoDto()), [IEventHub_1.EventReceiver.CLIENT]);
                    break;
                case RtcCommand_1.CmdType.RequestCancel:
                    //學生收到老師取消開始輔導邀請
                    await this.BecomeStartInvitingStatus(FudaoDefinition_1.InvitingStatus.InvitingCanceled);
                    await this.BecomeStatus(FudaoDefinition_1.Status.Ended);
                    await this.publishEventAsync(FudaoEvent_1.FudaoEvent.TeacherStartInvitationCanceledEvent(this.ToFudaoDto()), [IEventHub_1.EventReceiver.CLIENT]);
                    break;
                case RtcCommand_1.CmdType.ResponseAccept:
                    //老師收到學生接受開始輔導邀請
                    await this.BecomeStartInvitingStatus(FudaoDefinition_1.InvitingStatus.InvitingAccepted);
                    await this.publishEventAsync(FudaoEvent_1.FudaoEvent.StudentStartInvitationAcceptedEvent(this.ToFudaoDto()), [IEventHub_1.EventReceiver.CLIENT]);
                    break;
                case RtcCommand_1.CmdType.ResponseReject:
                    //老師收到學生拒絕開始輔導邀請
                    await this.BecomeStartInvitingStatus(FudaoDefinition_1.InvitingStatus.InvitingRejected);
                    await this.BecomeStatus(FudaoDefinition_1.Status.Ended);
                    await this.publishEventAsync(FudaoEvent_1.FudaoEvent.StudentStartInvitationRejectedEvent(this.ToFudaoDto()), [IEventHub_1.EventReceiver.CLIENT]);
                    break;
                case RtcCommand_1.CmdType.ResponseFail:
                    //老師收到學生處理開始輔導邀請失敗
                    await this.BecomeStartInvitingStatus(FudaoDefinition_1.InvitingStatus.None);
                    await this.BecomeStatus(FudaoDefinition_1.Status.Ended); //邀請失敗，結束
                    await this.publishEventAsync(FudaoEvent_1.FudaoEvent.FudaoStartFailedEvent(this.ToFudaoDto(), rtcCmd.message), [IEventHub_1.EventReceiver.CLIENT]);
                    break;
            }
        }
    }
    async CancelStartInvitationAsync(t) {
        if (!t.IsTeacher)
            throw new FudaoError(`${t} is not teacher`);
        if (this.Status !== FudaoDefinition_1.Status.Created)
            throw new FudaoError(`Status=${FudaoDefinition_1.Status} is wrong, it should be ${FudaoDefinition_1.Status.Created}`);
        if (this.StartInvitingStatus !== FudaoDefinition_1.InvitingStatus.InvitingSent)
            throw new FudaoError(`StartInvitingStatus=${this.StartInvitingStatus} is wrong, it should be ${FudaoDefinition_1.InvitingStatus.InvitingSent}`);
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            //老師取消開始輔導邀請
            await this.BecomeStartInvitingStatus(FudaoDefinition_1.InvitingStatus.InvitingCanceled);
            await this.BecomeStatus(FudaoDefinition_1.Status.Ended);
            const fudaoDto = this.ToFudaoDto();
            await this.sendCommandAsync(FudaoCommand_1.FudaoCommand.TeacherInviteStartFudaoCommand(fudaoDto, this.Student, RtcCommand_1.CmdType.RequestCancel));
            await this.publishEventAsync(FudaoEvent_1.FudaoEvent.TeacherStartInvitationCanceledEvent(this.ToFudaoDto()), [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    async AcceptStartInvitationAsync(student) {
        if (!student.IsStudent)
            throw new FudaoError(`${student} is not student`);
        if (this.Status !== FudaoDefinition_1.Status.Created)
            throw new FudaoError(`Wrong status=${FudaoDefinition_1.Status}, it should be ${FudaoDefinition_1.Status.Created}`);
        if (this.StartInvitingStatus !== FudaoDefinition_1.InvitingStatus.InvitingSent)
            throw new FudaoError(`StartInvitingStatus=${this.StartInvitingStatus} is wrong, it should be ${FudaoDefinition_1.InvitingStatus.InvitingSent}`);
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            //學生接受開始輔導邀請
            await this.BecomeStartInvitingStatus(FudaoDefinition_1.InvitingStatus.InvitingAccepted);
            await this.sendCommandAsync(FudaoCommand_1.FudaoCommand.TeacherInviteStartFudaoCommand(this.ToFudaoDto(), this.Teacher, RtcCommand_1.CmdType.ResponseAccept));
            await this.publishEventAsync(FudaoEvent_1.FudaoEvent.StudentStartInvitationAcceptedEvent(this.ToFudaoDto()), [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    async RejectStartInvitationAsync(student) {
        if (!student.IsStudent)
            throw new FudaoError(`${student} is student`);
        if (this.Status !== FudaoDefinition_1.Status.Created)
            throw new FudaoError(`Wrong status=${FudaoDefinition_1.Status}, it should be ${FudaoDefinition_1.Status.Created}`);
        if (this.StartInvitingStatus !== FudaoDefinition_1.InvitingStatus.InvitingSent)
            throw new FudaoError(`StartInvitingStatus=${this.StartInvitingStatus} is wrong, it should be ${FudaoDefinition_1.InvitingStatus.InvitingSent}`);
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            //學生拒絕開始輔導邀請
            await this.BecomeStartInvitingStatus(FudaoDefinition_1.InvitingStatus.InvitingRejected);
            await this.BecomeStatus(FudaoDefinition_1.Status.Ended);
            await this.sendCommandAsync(FudaoCommand_1.FudaoCommand.TeacherInviteStartFudaoCommand(this.ToFudaoDto(), this.Teacher, RtcCommand_1.CmdType.ResponseReject));
            await this.publishEventAsync(FudaoEvent_1.FudaoEvent.StudentStartInvitationRejectedEvent(this.ToFudaoDto()), [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    async NoResponseStartInvitationAsync(fudaoUser) {
        if (this.Status !== FudaoDefinition_1.Status.Created)
            throw new FudaoError(`Wrong status=${this.Status}, it should be ${FudaoDefinition_1.Status.Created}`);
        if (this.StartInvitingStatus !== FudaoDefinition_1.InvitingStatus.InvitingSent)
            throw new FudaoError(`StartInvitingStatus=${this.StartInvitingStatus} is wrong, it should be ${FudaoDefinition_1.InvitingStatus.InvitingSent}`);
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            //老師與學生回報學生無回應開始輔導邀請
            await this.BecomeStatus(FudaoDefinition_1.Status.Ended);
            await this.BecomeStartInvitingStatus(FudaoDefinition_1.InvitingStatus.None);
            await this.publishEventAsync(FudaoEvent_1.FudaoEvent.StudentStartInvitationNoResponseEvent(this.ToFudaoDto()), [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    async StartAsync(teacher) {
        if (!teacher.IsTeacher)
            throw new FudaoError(`${teacher} is not teacher`);
        if (this.Status !== FudaoDefinition_1.Status.Created)
            throw new FudaoError(`Wrong status=${this.Status}, it should be ${FudaoDefinition_1.Status.Created}`);
        if (this.StartInvitingStatus !== FudaoDefinition_1.InvitingStatus.InvitingAccepted)
            throw new FudaoError(`StartInvitingStatus=${this.StartInvitingStatus} is wrong, it should be ${FudaoDefinition_1.InvitingStatus.InvitingAccepted}`);
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            await this.BecomeStatus(FudaoDefinition_1.Status.Starting);
            //老師送開始輔導給輔導服務
            const cmd = FudaoCommand_1.FudaoCommand.TeacherStartFudaoCommand(this.ToFudaoDto());
            await this.sendCommandAsync(cmd);
            //var cmdResult = await SendCommandAsync(cmd);
            //// TODO: 先在這裡自行處理對方Blocking處理完畢回傳，等到有統一的機制再交由CommandHub作
            //if (cmdResult != RtcCommand.InvalidRtcCommand)
            //{
            //    await _commandHub?.ReceiveCommandAsync(cmdResult);
            //}
            //AssertStateTrue(cmdResult.Type == CmdType.ResponseAccept, $"Start fadao={Id} failed, reason={cmdResult.Message}");
        }
    }
    async OnStartCommandAsync(rtcCmd) {
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            switch (rtcCmd.type) {
                case RtcCommand_1.CmdType.RequestExecute:
                    break;
                case RtcCommand_1.CmdType.ResponseAccept:
                    if (this.Status === FudaoDefinition_1.Status.Starting) {
                        //老師收到輔導服務回傳開始成功
                        //開始啟動資料連線
                        if (!this.DataSession.IsValid())
                            throw new FudaoError("No valid data session.");
                        await this._sessionFacade.StartDataSessionAsync(this.DataSession, this.Teacher, this._localDataProvider, this._remoteDataReceiver);
                        await this.BecomeStatus(FudaoDefinition_1.Status.Started);
                        const student = new IEventHub_1.EventReceiver(this.Student.Id, this.Student.Name);
                        await this.publishEventAsync(FudaoEvent_1.FudaoEvent.FudaoStartedEvent(this.ToFudaoDto()), [IEventHub_1.EventReceiver.CLIENT, student]);
                    }
                    else {
                        //老師收到輔導服務回傳開始成功，但老師狀態有變
                        const wrongCurStatus = FudaoDefinition_1.Status;
                        await this.BecomeStatus(FudaoDefinition_1.Status.AbnormalEnded);
                        const student = new IEventHub_1.EventReceiver(this.Student.Id, this.Student.Name);
                        await this.publishEventAsync(FudaoEvent_1.FudaoEvent.FudaoStartFailedEvent(this.ToFudaoDto(), `Fudao.Status=${wrongCurStatus} is not corrrect.`), [IEventHub_1.EventReceiver.CLIENT, student]);
                    }
                    break;
                case RtcCommand_1.CmdType.ResponseFail:
                    {
                        //老師收到輔導服務回傳開始失敗
                        await this.BecomeStatus(FudaoDefinition_1.Status.AbnormalEnded);
                        const student = new IEventHub_1.EventReceiver(this.Student.Id, this.Student.Name);
                        await this.publishEventAsync(FudaoEvent_1.FudaoEvent.FudaoStartFailedEvent(this.ToFudaoDto(), rtcCmd.message), [IEventHub_1.EventReceiver.CLIENT, student]);
                    }
                    break;
            }
        }
    }
    async OnStartEventAsync(evt) {
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            //學生收到輔導開始
            if (this.Status === FudaoDefinition_1.Status.Started)
                return;
            //啟動資料連線
            if (!this.DataSession.IsValid())
                throw new FudaoError("No valid data session.");
            await this._sessionFacade.JoinDataSessionAsync(this.DataSession, this.Student, this._localDataProvider, this._remoteDataReceiver);
            await this.BecomeStatus(FudaoDefinition_1.Status.Started);
            await this.publishEventAsync(FudaoEvent_1.FudaoEvent.FudaoStartedEvent(this.ToFudaoDto()), [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    async OnFudaoStartFailed(evt) {
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            //學生收到輔導失敗Event
            await this.BecomeStatus(FudaoDefinition_1.Status.AbnormalEnded);
            await this.publishEventAsync(evt, [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    async InviteExtendAsync(teacher) {
        if (this.Status !== FudaoDefinition_1.Status.Started)
            throw new FudaoError(`Wrong status=${this.Status}, it should be ${FudaoDefinition_1.Status.Created}`);
        if (!teacher.IsTeacher)
            throw new FudaoError(`${teacher.Name} is not teacher.`);
        if (this.ExtendInvitingStatus === FudaoDefinition_1.InvitingStatus.InvitingSent)
            throw new FudaoError(`ExtendInvitingStatus=${this.ExtendInvitingStatus} is wrong`);
        if (!this.CanExtendFudao(teacher))
            throw new FudaoError("Can't extend fudao.");
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            //老師邀請學生延長輔導
            await this.BecomeExtendInvitingStatus(FudaoDefinition_1.InvitingStatus.InvitingSent);
            const fudaoDto = this.ToFudaoDto();
            await this.sendCommandAsync(FudaoCommand_1.FudaoCommand.TeacherInviteExtendFudaoCommand(fudaoDto, this.Student));
            await this.publishEventAsync(FudaoEvent_1.FudaoEvent.TeacherExtendInvitationSentEvent(fudaoDto), [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    async OnInviteExtendCommandAsync(rtcCmd) {
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            switch (rtcCmd.type) {
                case RtcCommand_1.CmdType.RequestExecute:
                    //學生收到延長輔導邀請
                    await this.BecomeExtendInvitingStatus(FudaoDefinition_1.InvitingStatus.InvitingSent);
                    await this.publishEventAsync(FudaoEvent_1.FudaoEvent.StudentExtendInvitationReceivedEvent(this.ToFudaoDto()), [IEventHub_1.EventReceiver.CLIENT]);
                    break;
                case RtcCommand_1.CmdType.RequestCancel:
                    //學生收到老師取消延長輔導邀請
                    await this.BecomeExtendInvitingStatus(FudaoDefinition_1.InvitingStatus.InvitingCanceled);
                    await this.publishEventAsync(FudaoEvent_1.FudaoEvent.TeacherExtendInvitationCanceledEvent(this.ToFudaoDto()), [IEventHub_1.EventReceiver.CLIENT]);
                    break;
                case RtcCommand_1.CmdType.ResponseAccept:
                    //老師收到學生接受延長輔導邀請
                    await this.BecomeExtendInvitingStatus(FudaoDefinition_1.InvitingStatus.InvitingAccepted);
                    await this.publishEventAsync(FudaoEvent_1.FudaoEvent.StudentExtendInvitionAcceptedEvent(this.ToFudaoDto()), [IEventHub_1.EventReceiver.CLIENT]);
                    break;
                case RtcCommand_1.CmdType.ResponseReject:
                    //老師收到學生拒絕延長輔導邀請
                    await this.BecomeExtendInvitingStatus(FudaoDefinition_1.InvitingStatus.InvitingRejected);
                    await this.publishEventAsync(FudaoEvent_1.FudaoEvent.StudentExtendInvitationRejectedEvent(this.ToFudaoDto()), [IEventHub_1.EventReceiver.CLIENT]);
                    await this.BecomeExtendInvitingStatus(FudaoDefinition_1.InvitingStatus.None); //重置結束輔導邀請狀態
                    break;
                case RtcCommand_1.CmdType.ResponseFail:
                    //老師邀請延長輔導失敗，當作沒發生，可以再發一次
                    await this.BecomeExtendInvitingStatus(FudaoDefinition_1.InvitingStatus.None);
                    await this.publishEventAsync(FudaoEvent_1.FudaoEvent.FudaoStartFailedEvent(this.ToFudaoDto(), rtcCmd.message), [IEventHub_1.EventReceiver.CLIENT]);
                    break;
            }
        }
    }
    async CancelExtendInvitationAsync(teacher) {
        if (!teacher.IsTeacher)
            throw new FudaoError(`${teacher} is not teacher`);
        if (this.Status !== FudaoDefinition_1.Status.Started)
            throw new FudaoError(`Wrong status=${this.Status}, it should be ${FudaoDefinition_1.Status.Started}`);
        if (this.ExtendInvitingStatus !== FudaoDefinition_1.InvitingStatus.InvitingSent)
            throw new FudaoError(`ExtendInvitingStatus=${this.ExtendInvitingStatus} is wrong, it should be ${FudaoDefinition_1.InvitingStatus.InvitingSent}`);
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            //老師取消邀請延長輔導邀請
            await this.BecomeExtendInvitingStatus(FudaoDefinition_1.InvitingStatus.InvitingCanceled);
            const fudaoDto = this.ToFudaoDto();
            //老師送出取消結束輔導Command
            await this.sendCommandAsync(FudaoCommand_1.FudaoCommand.TeacherInviteExtendFudaoCommand(fudaoDto, this.Student, RtcCommand_1.CmdType.RequestCancel));
            await this.publishEventAsync(FudaoEvent_1.FudaoEvent.TeacherExtendInvitationCanceledEvent(this.ToFudaoDto()), [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    async AcceptExtendInvitionAsync(student) {
        if (!student.IsStudent)
            throw new FudaoError(`${student} is not student.`);
        if (this.Status !== FudaoDefinition_1.Status.Started)
            throw new FudaoError(`Wrong status=${this.Status}, it should be ${FudaoDefinition_1.Status.Started}`);
        if (this.ExtendInvitingStatus !== FudaoDefinition_1.InvitingStatus.InvitingSent)
            throw new FudaoError(`ExtendInvitingStatus=${this.ExtendInvitingStatus} is wrong, it should be ${FudaoDefinition_1.InvitingStatus.InvitingSent}`);
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            //學生接受延長輔導邀請
            await this.BecomeExtendInvitingStatus(FudaoDefinition_1.InvitingStatus.InvitingAccepted);
            const fudaoDto = this.ToFudaoDto();
            await this.sendCommandAsync(FudaoCommand_1.FudaoCommand.TeacherInviteExtendFudaoCommand(fudaoDto, this.Teacher, RtcCommand_1.CmdType.ResponseAccept));
            await this.publishEventAsync(FudaoEvent_1.FudaoEvent.StudentExtendInvitionAcceptedEvent(this.ToFudaoDto()), [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    async RejectExtendInvitionAsync(student) {
        if (!student.IsStudent)
            throw new FudaoError(`${student} is not a student.`);
        if (this.Status !== FudaoDefinition_1.Status.Started)
            throw new FudaoError(`Wrong status=${this.Status}, it should be ${FudaoDefinition_1.Status.Started}`);
        if (this.ExtendInvitingStatus !== FudaoDefinition_1.InvitingStatus.InvitingSent)
            throw new FudaoError(`ExtendInvitingStatus=${this.ExtendInvitingStatus} is wrong, it should be ${FudaoDefinition_1.InvitingStatus.InvitingSent}`);
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            //學生拒絕延長輔導邀請
            await this.BecomeExtendInvitingStatus(FudaoDefinition_1.InvitingStatus.InvitingRejected);
            const fudaoDto = this.ToFudaoDto();
            await this.sendCommandAsync(FudaoCommand_1.FudaoCommand.TeacherInviteExtendFudaoCommand(fudaoDto, this.Teacher, RtcCommand_1.CmdType.ResponseReject));
            await this.publishEventAsync(FudaoEvent_1.FudaoEvent.StudentExtendInvitationRejectedEvent(this.ToFudaoDto()), [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    async NoResponseExtendInvitationAsync(fudaoUser) {
        if (this.Status !== FudaoDefinition_1.Status.Started)
            throw new FudaoError(`Wrong status=${this.Status}, it should be ${FudaoDefinition_1.Status.Started}`);
        if (this.ExtendInvitingStatus !== FudaoDefinition_1.InvitingStatus.InvitingSent)
            throw new FudaoError(`ExtendInvitingStatus=${this.ExtendInvitingStatus} is wrong, it should be ${FudaoDefinition_1.InvitingStatus.InvitingSent}`);
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            //學生無回應延長輔導，老師學生雙方繼續輔導
            await this.BecomeExtendInvitingStatus(FudaoDefinition_1.InvitingStatus.None);
            await this.publishEventAsync(FudaoEvent_1.FudaoEvent.StudentExtendInvitationNoResponseEvent(this.ToFudaoDto()), [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    async ExtendAsync(teacher) {
        if (this.Status !== FudaoDefinition_1.Status.Started)
            throw new FudaoError(`Wrong status=${this.Status}, it should be ${FudaoDefinition_1.Status.Started}`);
        if (!teacher.IsTeacher)
            throw new FudaoError(`${teacher} is not teacher`);
        if (this.ExtendInvitingStatus !== FudaoDefinition_1.InvitingStatus.InvitingAccepted)
            throw new FudaoError(`ExtendInvitingStatus=${this.ExtendInvitingStatus} is wrong, it should be ${FudaoDefinition_1.InvitingStatus.InvitingAccepted}`);
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            //老師送延長輔導給輔導服務
            await this.sendCommandAsync(FudaoCommand_1.FudaoCommand.TeacherExtendFudaoCommand(this.ToFudaoDto(), this.ExtendedTimes));
            //var cmdResult = await SendCommandAsync(TeacherExtendFudaoCommand(this.ToFudaoDto(), this.ExtendedTimes));
            //// TODO: 先在這裡自行處理對方Blocking處理完畢回傳，等到有統一的機制再交由CommandHub作
            //if (cmdResult != RtcCommand.InvalidRtcCommand)
            //{
            //    await _commandHub?.ReceiveCommandAsync(cmdResult);
            //}
        }
    }
    async OnExtendCommandAsync(rtcCmd) {
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            switch (rtcCmd.type) {
                case RtcCommand_1.CmdType.RequestExecute:
                    break;
                case RtcCommand_1.CmdType.ResponseAccept:
                    {
                        //老師收到輔導服務回傳延長成功
                        this._extendedTimes += 1;
                        await this._fudaoRepo.SaveAsync(this);
                        this._fudaoTimeCounter.StartCount(this.id); //處理在結束輔導時延長輔導的案例，讓輔導計時器開始
                        const student = new IEventHub_1.EventReceiver(this.Student.Id, this.Student.Name);
                        await this.publishEventAsync(FudaoEvent_1.FudaoEvent.FudaoExtendedEvent(this.ToFudaoDto()), [IEventHub_1.EventReceiver.CLIENT, student]);
                    }
                    break;
                case RtcCommand_1.CmdType.ResponseFail:
                    {
                        //老師收到輔導服務回傳延長失敗
                        const student = new IEventHub_1.EventReceiver(this.Student.Id, this.Student.Name);
                        await this.publishEventAsync(FudaoEvent_1.FudaoEvent.FudaoStartFailedEvent(this.ToFudaoDto(), rtcCmd.message), [IEventHub_1.EventReceiver.CLIENT, student]);
                    }
                    break;
            }
        }
    }
    async OnExtendEventAsync(evt) {
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            //學生收到輔導延長
            const fudaoDto = new FudaoDto_1.FudaoDto(evt.bodyTo());
            this._extendedTimes = fudaoDto.extendedTimes;
            await this._fudaoRepo.SaveAsync(this);
            this._fudaoTimeCounter.StartCount(this.id); //處理在結束輔導時延長輔導的案例，讓輔導計時器開始
            await this.publishEventAsync(FudaoEvent_1.FudaoEvent.FudaoExtendedEvent(this.ToFudaoDto()), [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    CanExtendFudao(teacher) {
        return teacher.IsTeacher && (this.ExtendedTimes < MAX_EXTENDED_TIMES);
    }
    async InviteEndAsync(teacher) {
        if (this.Status !== FudaoDefinition_1.Status.Started)
            throw new FudaoError(`Wrong status=${this.Status}, it should be ${FudaoDefinition_1.Status.Started}`);
        if (!teacher.IsTeacher)
            throw new FudaoError(`${teacher} is not teacher.`);
        if (this.EndInvitingStatus === FudaoDefinition_1.InvitingStatus.InvitingSent)
            throw new FudaoError(`EndInvitingStatus=${this.EndInvitingStatus} is wrong`);
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            //老師邀請學生結束輔導
            await this.BecomeEndInvitingStatus(FudaoDefinition_1.InvitingStatus.InvitingSent);
            const fudaoDto = this.ToFudaoDto();
            await this.sendCommandAsync(FudaoCommand_1.FudaoCommand.TeacherInviteEndFudaoCommand(fudaoDto, this.Student));
            await this.publishEventAsync(FudaoEvent_1.FudaoEvent.TeacherEndInvitationSentEvent(fudaoDto), [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    async OnInviteEndCommandAsync(rtcCmd) {
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            switch (rtcCmd.type) {
                case RtcCommand_1.CmdType.RequestExecute:
                    //學生收到結束輔導邀請
                    await this.BecomeEndInvitingStatus(FudaoDefinition_1.InvitingStatus.InvitingSent);
                    await this.publishEventAsync(FudaoEvent_1.FudaoEvent.StudentEndInvitationReceivedEvent(this.ToFudaoDto()), [IEventHub_1.EventReceiver.CLIENT]);
                    break;
                case RtcCommand_1.CmdType.RequestCancel:
                    //學生收到老師取消結束輔導邀請
                    await this.BecomeEndInvitingStatus(FudaoDefinition_1.InvitingStatus.InvitingCanceled);
                    await this.publishEventAsync(FudaoEvent_1.FudaoEvent.TeacherEndInvitationCanceledEvent(this.ToFudaoDto()), [IEventHub_1.EventReceiver.CLIENT]);
                    break;
                case RtcCommand_1.CmdType.ResponseAccept:
                    //老師收到學生接受結束輔導邀請
                    await this.BecomeEndInvitingStatus(FudaoDefinition_1.InvitingStatus.InvitingAccepted);
                    await this.publishEventAsync(FudaoEvent_1.FudaoEvent.StudentEndInvitionAcceptedEvent(this.ToFudaoDto()), [IEventHub_1.EventReceiver.CLIENT]);
                    break;
                case RtcCommand_1.CmdType.ResponseReject:
                    //老師收到學生拒絕結束輔導邀請
                    await this.BecomeEndInvitingStatus(FudaoDefinition_1.InvitingStatus.InvitingRejected);
                    await this.publishEventAsync(FudaoEvent_1.FudaoEvent.StudentEndInvitationRejectedEvent(this.ToFudaoDto()), [IEventHub_1.EventReceiver.CLIENT]);
                    await this.BecomeEndInvitingStatus(FudaoDefinition_1.InvitingStatus.None); //重置結束輔導邀請狀態
                    break;
                case RtcCommand_1.CmdType.ResponseFail:
                    //老師邀請結束輔導失敗，當作沒發生，可以再發一次
                    await this.BecomeEndInvitingStatus(FudaoDefinition_1.InvitingStatus.None);
                    await this.publishEventAsync(FudaoEvent_1.FudaoEvent.FudaoStartFailedEvent(this.ToFudaoDto(), rtcCmd.message), [IEventHub_1.EventReceiver.CLIENT]);
                    break;
            }
        }
    }
    async CancelEndInvitationAsync(teacher) {
        if (this.Status !== FudaoDefinition_1.Status.Started)
            throw new FudaoError(`Wrong status=${FudaoDefinition_1.Status}, it should be ${FudaoDefinition_1.Status.Started}`);
        if (!teacher.IsTeacher)
            throw new FudaoError(`${teacher} is not teacher`);
        if (this.EndInvitingStatus !== FudaoDefinition_1.InvitingStatus.InvitingSent)
            throw new FudaoError(`EndInvitingStatus=${this.EndInvitingStatus} is wrong, it should be ${FudaoDefinition_1.InvitingStatus.InvitingSent}`);
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            //老師取消結束輔導邀請
            await this.BecomeEndInvitingStatus(FudaoDefinition_1.InvitingStatus.InvitingCanceled);
            const fudaoDto = this.ToFudaoDto();
            //老師送出取消結束輔導Command
            await this.sendCommandAsync(FudaoCommand_1.FudaoCommand.TeacherInviteEndFudaoCommand(fudaoDto, this.Student, RtcCommand_1.CmdType.RequestCancel));
            await this.publishEventAsync(FudaoEvent_1.FudaoEvent.TeacherEndInvitationCanceledEvent(this.ToFudaoDto()), [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    async AcceptEndInvitionAsync(student) {
        if (this.Status !== FudaoDefinition_1.Status.Started)
            throw new FudaoError(`Wrong status=${this.Status}, it should be ${FudaoDefinition_1.Status.Started}`);
        if (!student.IsStudent)
            throw new FudaoError(`${student} is not teacher.`);
        if (this.EndInvitingStatus !== FudaoDefinition_1.InvitingStatus.InvitingSent)
            throw new FudaoError(`EndInvitingStatus=${this.EndInvitingStatus} is wrong, it should be ${FudaoDefinition_1.InvitingStatus.InvitingSent}`);
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            //學生接受結束輔導邀請
            await this.BecomeEndInvitingStatus(FudaoDefinition_1.InvitingStatus.InvitingAccepted);
            const fudaoDto = this.ToFudaoDto();
            await this.sendCommandAsync(FudaoCommand_1.FudaoCommand.TeacherInviteEndFudaoCommand(fudaoDto, this.Teacher, RtcCommand_1.CmdType.ResponseAccept));
            await this.publishEventAsync(FudaoEvent_1.FudaoEvent.StudentEndInvitionAcceptedEvent(this.ToFudaoDto()), [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    async RejectEndInvitionAsync(student) {
        if (this.Status !== FudaoDefinition_1.Status.Started)
            throw new FudaoError(`Wrong status=${this.Status}, it should be ${FudaoDefinition_1.Status.Started}`);
        if (!student.IsStudent)
            throw new FudaoError(`${student} is not teacher.`);
        if (this.EndInvitingStatus !== FudaoDefinition_1.InvitingStatus.InvitingSent)
            throw new FudaoError(`EndInvitingStatus=${this.EndInvitingStatus} is wrong, it should be ${FudaoDefinition_1.InvitingStatus.InvitingSent}`);
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            //學生拒絕結束輔導邀請
            await this.BecomeEndInvitingStatus(FudaoDefinition_1.InvitingStatus.InvitingRejected);
            const fudaoDto = this.ToFudaoDto();
            await this.sendCommandAsync(FudaoCommand_1.FudaoCommand.TeacherInviteEndFudaoCommand(fudaoDto, this.Teacher, RtcCommand_1.CmdType.ResponseReject));
            await this.publishEventAsync(FudaoEvent_1.FudaoEvent.StudentEndInvitationRejectedEvent(this.ToFudaoDto()), [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    async NoResponseEndInvitationAsync(fudaoUser) {
        if (this.Status !== FudaoDefinition_1.Status.Started)
            throw new FudaoError(`Wrong status=${this.Status}, it should be ${FudaoDefinition_1.Status.Started}`);
        if (this.EndInvitingStatus !== FudaoDefinition_1.InvitingStatus.InvitingSent)
            throw new FudaoError(`EndInvitingStatus=${this.EndInvitingStatus} is wrong, it should be ${FudaoDefinition_1.InvitingStatus.InvitingSent}`);
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            //學生無回應結束輔導，老師學生雙方繼續輔導
            await this.BecomeEndInvitingStatus(FudaoDefinition_1.InvitingStatus.None);
            await this.publishEventAsync(FudaoEvent_1.FudaoEvent.StudentEndInvitationNoResponseEvent(this.ToFudaoDto()), [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    async EndAsync(teacher) {
        if (this.Status !== FudaoDefinition_1.Status.Started)
            throw new FudaoError(`Wrong status=${this.Status}, it should be ${FudaoDefinition_1.Status.Started}`);
        if (!teacher.IsTeacher)
            throw new FudaoError(`${teacher} is not teacher`);
        const isTimeUp = this.PassedTimeMilliSecond >= this.CalculateTotalTime().asMilliseconds();
        if (!isTimeUp && this.EndInvitingStatus !== FudaoDefinition_1.InvitingStatus.InvitingAccepted)
            throw new FudaoError(`EndInvitingStatus=${this.EndInvitingStatus} is wrong, it should be ${FudaoDefinition_1.InvitingStatus.InvitingAccepted}`);
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            await this.BecomeStatus(FudaoDefinition_1.Status.Ended);
            //老師送結束輔導給輔導服務
            await this.sendCommandAsync(FudaoCommand_1.FudaoCommand.TeacherEndFudaoCommand(this.ToFudaoDto()));
            //var cmdResult = await SendCommandAsync(FudaoCommand.TeacherEndFudaoCommand(this.ToFudaoDto()));
            //// TODO: 先在這裡自行處理對方Blocking處理完畢回傳，等到有統一的機制再交由CommandHub作
            //if (cmdResult != RtcCommand.InvalidRtcCommand)
            //{
            //    await _commandHub?.ReceiveCommandAsync(cmdResult);
            //}
        }
    }
    async OnEndCommandAsync(rtcCmd) {
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            switch (rtcCmd.type) {
                case RtcCommand_1.CmdType.RequestExecute:
                    break;
                case RtcCommand_1.CmdType.ResponseAccept:
                    {
                        //老師收到輔導服務回傳結束成功
                        await this.BecomeStatus(FudaoDefinition_1.Status.Ended);
                        const student = new IEventHub_1.EventReceiver(this.Student.Id, this.Student.Name);
                        await this.publishEventAsync(FudaoEvent_1.FudaoEvent.FudaoEndedEvent(this.ToFudaoDto()), [IEventHub_1.EventReceiver.CLIENT, student]);
                        //關閉DataSession
                        await this._sessionFacade.StopSessionAsync(this.DataSession, this.Teacher);
                    }
                    break;
                case RtcCommand_1.CmdType.ResponseFail:
                    {
                        //老師收到輔導服務回傳結束失敗，還是要結束
                        await this.BecomeStatus(FudaoDefinition_1.Status.AbnormalEnded);
                        const student = new IEventHub_1.EventReceiver(this.Student.Id, this.Student.Name);
                        await this.publishEventAsync(FudaoEvent_1.FudaoEvent.FudaoEndedEvent(this.ToFudaoDto()), [IEventHub_1.EventReceiver.CLIENT, student]);
                        //關閉DataSession
                        await this._sessionFacade.StopSessionAsync(this.DataSession, this.Teacher);
                    }
                    break;
            }
        }
    }
    async OnEndEventAsync(evt) {
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            //學生收到輔導結束
            await this.BecomeStatus(FudaoDefinition_1.Status.Ended);
            await this.publishEventAsync(FudaoEvent_1.FudaoEvent.FudaoEndedEvent(this.ToFudaoDto()), [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    async InterruptAsync(fudaoUser) {
        if (this.Status !== FudaoDefinition_1.Status.Started)
            throw new FudaoError(`Wrong status=${this.Status}, it should be ${FudaoDefinition_1.Status.Started}`);
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            let needToNotifyEr = IEventHub_1.EventReceiver.Nobody;
            if (fudaoUser.Is(this.Teacher)) {
                needToNotifyEr = new IEventHub_1.EventReceiver(this.Student.Id, this.Student.Name);
            }
            else {
                needToNotifyEr = new IEventHub_1.EventReceiver(this.Teacher.Id, this.Teacher.Name);
            }
            await this.InternalInterruptAsync(needToNotifyEr);
        }
    }
    async InternalInterruptAsync(needToNotifyEventReceiver) {
        if (this.Status !== FudaoDefinition_1.Status.Started)
            throw new FudaoError(`Wrong status=${this.Status}, it should be ${FudaoDefinition_1.Status.Started}`);
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            await this.BecomeStatus(FudaoDefinition_1.Status.Interrupted);
            const receivers = [];
            receivers.push(IEventHub_1.EventReceiver.CLIENT);
            if (needToNotifyEventReceiver !== IEventHub_1.EventReceiver.Nobody) {
                receivers.push(needToNotifyEventReceiver);
            }
            await this.publishEventAsync(FudaoEvent_1.FudaoEvent.FudaoEndedEvent(this.ToFudaoDto()), receivers);
            //關閉DataSession
            await this._sessionFacade.StopSessionAsync(this.DataSession, this.Teacher);
        }
    }
    async InviteStartSessionAsync(teacher, st) {
        if (!teacher.Is(this.Teacher))
            throw new FudaoError(`${teacher} is not teacher.`);
        if (!this.IsFudaoSupportedSession(st))
            throw new FudaoError(`Not supported SessionType=${st}`);
        if (this.Status !== FudaoDefinition_1.Status.Started)
            throw new FudaoError(`Wrong status=${this.Status}, it should be ${FudaoDefinition_1.Status.Started}`);
        if (this.SessionInvitingStatus.InvitingStatus === FudaoDefinition_1.InvitingStatus.InvitingSent)
            throw new FudaoError(`SessionInvitingStatus=${this.SessionInvitingStatus} is wrong.`);
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            const fs = await this._sessionFacade.RequestToStartSessionAsync(st, teacher, [this.Student]);
            if (!fs.IsValid())
                throw new FudaoError("Request to start session failed.");
            const fudaoDto = this.ToFudaoDto();
            await this.sendCommandAsync(FudaoCommand_1.FudaoCommand.TeacherInviteStartSessionCommand(fudaoDto, fs, this.Student));
            await this.BecomeSessionInvitingStatus(fs, FudaoDefinition_1.InvitingStatus.InvitingSent);
            return fs;
        }
    }
    async OnInviteStartSessionCommandAsync(rtcCmd) {
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            const fs = new FudaoDefinition_1.FudaoSession(rtcCmd.contentTo());
            switch (rtcCmd.type) {
                case RtcCommand_1.CmdType.RequestExecute:
                    //學生收到開始Session邀請
                    await this.BecomeSessionInvitingStatus(fs, FudaoDefinition_1.InvitingStatus.InvitingSent);
                    await this.publishEventAsync(FudaoEvent_1.FudaoEvent.StudentStartSessionInvitationReceivedEvent(this.ToFudaoDto(), fs), [IEventHub_1.EventReceiver.CLIENT]);
                    break;
                case RtcCommand_1.CmdType.RequestCancel:
                    //學生收到老師取消開始Session邀請
                    await this.BecomeSessionInvitingStatus(fs, FudaoDefinition_1.InvitingStatus.InvitingCanceled);
                    await this.publishEventAsync(FudaoEvent_1.FudaoEvent.TeacherStartSessionInvitationCanceledEvent(this.ToFudaoDto(), fs), [IEventHub_1.EventReceiver.CLIENT]);
                    break;
                case RtcCommand_1.CmdType.ResponseAccept:
                    //老師收到學生接受開始Session邀請
                    await this.BecomeSessionInvitingStatus(fs, FudaoDefinition_1.InvitingStatus.InvitingAccepted);
                    await this.AddSessionIsBelongToSelf(fs.Id); //老師收到學生接受Session才有效
                    await this.publishEventAsync(FudaoEvent_1.FudaoEvent.StudentStartSessionInvitationAcceptedEvent(this.ToFudaoDto(), fs), [IEventHub_1.EventReceiver.CLIENT]);
                    break;
                case RtcCommand_1.CmdType.ResponseReject:
                    //老師收到學生拒絕開始Session邀請
                    await this.BecomeSessionInvitingStatus(fs, FudaoDefinition_1.InvitingStatus.InvitingRejected);
                    await this.publishEventAsync(FudaoEvent_1.FudaoEvent.StudentStartSessionInvitationRejectedEvent(this.ToFudaoDto(), fs), [IEventHub_1.EventReceiver.CLIENT]);
                    await this.ResetSessionInvitingStatus(); //重置開始Session邀請狀態
                    break;
                case RtcCommand_1.CmdType.ResponseFail:
                    //老師邀請開始Session失敗，當作沒發生，可以再發一次
                    await this.ResetSessionInvitingStatus();
                    await this.publishEventAsync(FudaoEvent_1.FudaoEvent.FudaoSessionFailedEvent(TypeScriptUtils_1.NewTuple3(this.ToFudaoDto(), fs, rtcCmd.message)), [IEventHub_1.EventReceiver.CLIENT]);
                    break;
            }
        }
    }
    async CancelStartSessionInvitionAsync(teacher, fs) {
        if (!teacher.Is(this.Teacher))
            throw new FudaoError(`${teacher} is not teacher`);
        if (this.Status !== FudaoDefinition_1.Status.Started)
            throw new FudaoError(`{nameof(Status)}=${FudaoDefinition_1.Status} is wrong, it should be ${FudaoDefinition_1.Status.Started}`);
        if (fs.Id !== this.SessionInvitingStatus.SessionId)
            throw new FudaoError(`Canceling not processing session=${fs}`);
        if (this.SessionInvitingStatus.InvitingStatus !== FudaoDefinition_1.InvitingStatus.InvitingSent)
            throw new FudaoError(`SessionInvitingStatus.InvitingStatus=${this.SessionInvitingStatus.InvitingStatus} is wrong, it should be ${FudaoDefinition_1.InvitingStatus.InvitingSent}`);
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            await this.BecomeSessionInvitingStatus(fs, FudaoDefinition_1.InvitingStatus.InvitingCanceled);
            const fudaoDto = this.ToFudaoDto();
            await this.sendCommandAsync(FudaoCommand_1.FudaoCommand.TeacherInviteStartSessionCommand(fudaoDto, fs, this.Student, RtcCommand_1.CmdType.RequestCancel));
            await this.publishEventAsync(FudaoEvent_1.FudaoEvent.TeacherStartSessionInvitationCanceledEvent(this.ToFudaoDto(), fs), [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    async AcceptStartSessionInvitionAsync(student, fs) {
        if (!student.Is(this.Student))
            throw new FudaoError(`${student} is not student`);
        if (this.Status !== FudaoDefinition_1.Status.Started)
            throw new FudaoError(`Wrong status=${this.Status}, it should be ${FudaoDefinition_1.Status.Started}`);
        if (fs.Id !== this.SessionInvitingStatus.SessionId)
            throw new FudaoError(`Canceling not processing session=${fs}`);
        if (this.SessionInvitingStatus.InvitingStatus !== FudaoDefinition_1.InvitingStatus.InvitingSent)
            throw new FudaoError(`SessionInvitingStatus.InvitingStatus=${this.SessionInvitingStatus.InvitingStatus} is wrong, it should be ${FudaoDefinition_1.InvitingStatus.InvitingSent}`);
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            await this.BecomeSessionInvitingStatus(fs, FudaoDefinition_1.InvitingStatus.InvitingAccepted);
            await this.AddSessionIsBelongToSelf(fs.Id); //學生接受Session之後Session才屬於輔導
            const fudaoDto = this.ToFudaoDto();
            await this.sendCommandAsync(FudaoCommand_1.FudaoCommand.TeacherInviteStartSessionCommand(fudaoDto, fs, this.Teacher, RtcCommand_1.CmdType.ResponseAccept));
            await this.publishEventAsync(FudaoEvent_1.FudaoEvent.StudentStartSessionInvitationAcceptedEvent(this.ToFudaoDto(), fs), [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    async RejectStartSessionInvitionAsync(student, fs) {
        if (!student.Is(this.Student))
            throw new FudaoError(`${student} is not student`);
        if (this.Status !== FudaoDefinition_1.Status.Started)
            throw new FudaoError(`Wrong status=${this.Status}, it should be ${FudaoDefinition_1.Status.Started}`);
        if (fs.Id !== this.SessionInvitingStatus.SessionId)
            throw new FudaoError(`Canceling not processing session=${fs}`);
        if (this.SessionInvitingStatus.InvitingStatus !== FudaoDefinition_1.InvitingStatus.InvitingSent)
            throw new FudaoError(`SessionInvitingStatus.InvitingStatus=${this.SessionInvitingStatus.InvitingStatus} is wrong, it should be ${FudaoDefinition_1.InvitingStatus.InvitingSent}`);
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            await this.BecomeSessionInvitingStatus(fs, FudaoDefinition_1.InvitingStatus.InvitingRejected);
            const fudaoDto = this.ToFudaoDto();
            await this.sendCommandAsync(FudaoCommand_1.FudaoCommand.TeacherInviteStartSessionCommand(fudaoDto, fs, this.Teacher, RtcCommand_1.CmdType.ResponseReject));
            await this.publishEventAsync(FudaoEvent_1.FudaoEvent.StudentStartSessionInvitationRejectedEvent(this.ToFudaoDto(), fs), [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    async NoResponseStartSessionInvitionAsync(fudaoUser, fs) {
        if (!fudaoUser.Is(this.Teacher) && !fudaoUser.Is(this.Student))
            throw new FudaoError(`${fudaoUser} is not belong this Fudao=${this.id}`);
        if (this.Status !== FudaoDefinition_1.Status.Started)
            throw new FudaoError(`Wrong status=${this.Status}, it should be ${FudaoDefinition_1.Status.Started}`);
        if (fs.Id !== this.SessionInvitingStatus.SessionId)
            throw new FudaoError(`Canceling not processing session=${fs}`);
        if (this.SessionInvitingStatus.InvitingStatus !== FudaoDefinition_1.InvitingStatus.InvitingSent)
            throw new FudaoError(`SessionInvitingStatus.InvitingStatus=${this.SessionInvitingStatus.InvitingStatus} is wrong, it should be ${FudaoDefinition_1.InvitingStatus.InvitingSent}`);
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            //學生無回應，老師學生雙方自行重設狀態
            await this.ResetSessionInvitingStatus();
            const fudaoDto = this.ToFudaoDto();
            await this.publishEventAsync(FudaoEvent_1.FudaoEvent.StudentStartSessionInvitationNoResponseEvent(this.ToFudaoDto(), fs), [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    async StartFudaoSessionAsync(fudaoUser, fs, videoContainer) {
        if (!fs.IsValid())
            throw new FudaoError(`${fs} is not valid {nameof(FudaoSession)}`);
        if (!this.IsSessionBelongToThisFudao(fs))
            throw new FudaoError(`${fs} is not belong to here`);
        if (this.SessionInvitingStatus.InvitingStatus !== FudaoDefinition_1.InvitingStatus.InvitingAccepted)
            throw new FudaoError(`SessionInvitingStatus.InvitingStatus=${this.SessionInvitingStatus.InvitingStatus} is wrong, it should be ${FudaoDefinition_1.InvitingStatus.InvitingAccepted}`);
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            if (this.Teacher.Is(fudaoUser)) {
                await this._sessionFacade.StartSessionAsync(fs, fudaoUser, videoContainer);
            }
            else if (this.Student.Is(fudaoUser)) {
                await this._sessionFacade.JoinSessionAsync(fs, fudaoUser, videoContainer);
            }
        }
    }
    async OnStartFudaoSessionEventAsync(evt) {
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            const fudaoSession = new FudaoDefinition_1.FudaoSession(evt.bodyTo());
            if (fudaoSession.Id === this.LastInvitedSessionId()) {
                //MultiMedia FudaoSession.
                switch (evt.name) {
                    case FudaoEvent_1.FudaoEvent.StudentStartFudaoSessionReceived:
                        await this.publishEventAsync(evt, [IEventHub_1.EventReceiver.CLIENT]);
                        break;
                    case FudaoEvent_1.FudaoEvent.FudaoSessionInited:
                        await this.publishEventAsync(evt, [IEventHub_1.EventReceiver.CLIENT]);
                        break;
                    case FudaoEvent_1.FudaoEvent.FudaoSessionStarted:
                        await this.publishEventAsync(evt, [IEventHub_1.EventReceiver.CLIENT]);
                        break;
                }
            }
            else if (fudaoSession.Id === this.DataSession.Id) {
                //Data Session，開始就開始不用做事情
            }
        }
    }
    LastInvitedSessionId() {
        return this.SessionInvitingStatus.SessionId;
    }
    async InviteEndSessionAsync(teacher, fs) {
        if (!teacher.Is(this.Teacher))
            throw new FudaoError(`${teacher} is not teacher belong to this fudao.`);
        if (!this.IsSessionBelongToThisFudao(fs))
            throw new FudaoError(`${fs} is not belong to here`);
        if (this.SessionInvitingStatus.InvitingStatus === FudaoDefinition_1.InvitingStatus.InvitingSent)
            throw new FudaoError(`SessionInvitingStatus=${this.SessionInvitingStatus} is wrong.`);
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            const fudaoDto = this.ToFudaoDto();
            await this.sendCommandAsync(FudaoCommand_1.FudaoCommand.TeacherInviteEndSessionCommand(fudaoDto, fs, this.Student));
            await this.BecomeSessionInvitingStatus(fs, FudaoDefinition_1.InvitingStatus.InvitingSent);
        }
    }
    async OnInviteEndSessionCommandAsync(rtcCmd) {
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            const fs = new FudaoDefinition_1.FudaoSession(rtcCmd.contentTo());
            switch (rtcCmd.type) {
                case RtcCommand_1.CmdType.RequestExecute:
                    //學生收到結束Session邀請
                    await this.BecomeSessionInvitingStatus(fs, FudaoDefinition_1.InvitingStatus.InvitingSent);
                    await this.publishEventAsync(FudaoEvent_1.FudaoEvent.StudentEndSessionInvitationReceivedEvent(this.ToFudaoDto(), fs), [IEventHub_1.EventReceiver.CLIENT]);
                    break;
                case RtcCommand_1.CmdType.RequestCancel:
                    //學生收到老師取消結束Session邀請
                    await this.BecomeSessionInvitingStatus(fs, FudaoDefinition_1.InvitingStatus.InvitingCanceled);
                    await this.publishEventAsync(FudaoEvent_1.FudaoEvent.TeacherEndSessionInvitationCanceledEvent(this.ToFudaoDto(), fs), [IEventHub_1.EventReceiver.CLIENT]);
                    break;
                case RtcCommand_1.CmdType.ResponseAccept:
                    //老師收到學生接受結束Session邀請
                    await this.BecomeSessionInvitingStatus(fs, FudaoDefinition_1.InvitingStatus.InvitingAccepted);
                    await this.publishEventAsync(FudaoEvent_1.FudaoEvent.StudentEndSessionInvitionAcceptedEvent(this.ToFudaoDto(), fs), [IEventHub_1.EventReceiver.CLIENT]);
                    break;
                case RtcCommand_1.CmdType.ResponseReject:
                    //老師收到學生拒絕結束Session邀請
                    await this.BecomeSessionInvitingStatus(fs, FudaoDefinition_1.InvitingStatus.InvitingRejected);
                    await this.publishEventAsync(FudaoEvent_1.FudaoEvent.StudentEndSessionInvitationRejectedEvent(this.ToFudaoDto(), fs), [IEventHub_1.EventReceiver.CLIENT]);
                    await this.ResetSessionInvitingStatus(); //重置開始Session邀請狀態
                    break;
                case RtcCommand_1.CmdType.ResponseFail:
                    //老師邀請結束Session失敗，當作沒發生，可以再發一次
                    await this.ResetSessionInvitingStatus();
                    await this.publishEventAsync(FudaoEvent_1.FudaoEvent.FudaoSessionFailedEvent(TypeScriptUtils_1.NewTuple3(this.ToFudaoDto(), fs, rtcCmd.message)), [IEventHub_1.EventReceiver.CLIENT]);
                    break;
            }
        }
    }
    async CancelEndSessionInvitionAsync(teacher, fs) {
        if (!teacher.Is(this.Teacher))
            throw new FudaoError(`${teacher} is not teacher belong to this fudao.`);
        if (!this.IsSessionBelongToThisFudao(fs))
            throw new FudaoError(`${fs} is not belong to here`);
        if (fs.Id !== this.SessionInvitingStatus.SessionId)
            throw new FudaoError(`Canceling not processing session=${fs}`);
        if (this.SessionInvitingStatus.InvitingStatus !== FudaoDefinition_1.InvitingStatus.InvitingSent)
            throw new FudaoError(`SessionInvitingStatus.InvitingStatus=${this.SessionInvitingStatus.InvitingStatus} is wrong, it should be ${FudaoDefinition_1.InvitingStatus.InvitingSent}`);
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            await this.BecomeSessionInvitingStatus(fs, FudaoDefinition_1.InvitingStatus.InvitingCanceled);
            const fudaoDto = this.ToFudaoDto();
            await this.sendCommandAsync(FudaoCommand_1.FudaoCommand.TeacherInviteEndSessionCommand(fudaoDto, fs, this.Student, RtcCommand_1.CmdType.RequestCancel));
            await this.publishEventAsync(FudaoEvent_1.FudaoEvent.TeacherEndSessionInvitationCanceledEvent(this.ToFudaoDto(), fs), [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    async AcceptEndSessionInvitionAsync(student, fs) {
        if (!student.Is(this.Student))
            throw new FudaoError(`${student} is not student belong to this fudao.`);
        if (!this.IsSessionBelongToThisFudao(fs))
            throw new FudaoError(`${fs} is not belong to here`);
        if (fs.Id !== this.SessionInvitingStatus.SessionId)
            throw new FudaoError(`Accepting not processing session=${fs}`);
        if (this.SessionInvitingStatus.InvitingStatus !== FudaoDefinition_1.InvitingStatus.InvitingSent)
            throw new FudaoError(`SessionInvitingStatus.InvitingStatus=${this.SessionInvitingStatus.InvitingStatus} is wrong, it should be ${FudaoDefinition_1.InvitingStatus.InvitingSent}`);
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            await this.BecomeSessionInvitingStatus(fs, FudaoDefinition_1.InvitingStatus.InvitingAccepted);
            const fudaoDto = this.ToFudaoDto();
            await this.sendCommandAsync(FudaoCommand_1.FudaoCommand.TeacherInviteEndSessionCommand(fudaoDto, fs, this.Teacher, RtcCommand_1.CmdType.ResponseAccept));
            await this.publishEventAsync(FudaoEvent_1.FudaoEvent.StudentEndSessionInvitionAcceptedEvent(this.ToFudaoDto(), fs), [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    async RejectEndSessionInvitionAsync(student, fs) {
        if (!student.Is(this.Student))
            throw new FudaoError(`${student} is not student belong to this fudao.`);
        if (!this.IsSessionBelongToThisFudao(fs))
            throw new FudaoError(`${fs} is not belong to here`);
        if (fs.Id !== this.SessionInvitingStatus.SessionId)
            throw new FudaoError(`Rejecting not processing session=${fs}`);
        if (this.SessionInvitingStatus.InvitingStatus !== FudaoDefinition_1.InvitingStatus.InvitingSent)
            throw new FudaoError(`SessionInvitingStatus.InvitingStatus=${this.SessionInvitingStatus.InvitingStatus} is wrong, it should be ${FudaoDefinition_1.InvitingStatus.InvitingSent}`);
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            await this.BecomeSessionInvitingStatus(fs, FudaoDefinition_1.InvitingStatus.InvitingRejected);
            const fudaoDto = this.ToFudaoDto();
            await this.sendCommandAsync(FudaoCommand_1.FudaoCommand.TeacherInviteEndSessionCommand(fudaoDto, fs, this.Teacher, RtcCommand_1.CmdType.ResponseReject));
            await this.publishEventAsync(FudaoEvent_1.FudaoEvent.StudentEndSessionInvitationRejectedEvent(this.ToFudaoDto(), fs), [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    async NoResponseEndSessionInvitionAsync(fudaoUser, fs) {
        if (!fudaoUser.Is(this.Teacher) && !fudaoUser.Is(this.Student))
            throw new FudaoError(`${fudaoUser} is not belong this Fudao=${this.id}`);
        if (!this.IsSessionBelongToThisFudao(fs))
            throw new FudaoError(`${fs} is not belong to here`);
        if (fs.Id !== this.SessionInvitingStatus.SessionId)
            throw new FudaoError(`No responsing not processing session=${fs}`);
        if (this.SessionInvitingStatus.InvitingStatus !== FudaoDefinition_1.InvitingStatus.InvitingSent)
            throw new FudaoError(`SessionInvitingStatus.InvitingStatus=${this.SessionInvitingStatus.InvitingStatus} is wrong, it should be ${FudaoDefinition_1.InvitingStatus.InvitingSent}`);
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            //學生無回應，老師學生雙方自行重設狀態
            await this.ResetSessionInvitingStatus();
            const fudaoDto = this.ToFudaoDto();
            await this.publishEventAsync(FudaoEvent_1.FudaoEvent.StudentEndSessionInvitationNoResponseEvent(fudaoDto, fs), [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    async EndFudaoSessionAsync(teacher, fs) {
        if (!teacher.Is(this.Teacher))
            throw new FudaoError(`${teacher} is not belong to this fudao.`);
        if (!this.IsSessionBelongToThisFudao(fs))
            throw new FudaoError(`${fs} is not belong to here`);
        if (this.SessionInvitingStatus.InvitingStatus !== FudaoDefinition_1.InvitingStatus.InvitingAccepted)
            throw new FudaoError(`SessionInvitingStatus.InvitingStatus=${this.SessionInvitingStatus.InvitingStatus} is wrong, it should be ${FudaoDefinition_1.InvitingStatus.InvitingAccepted}`);
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            await this._sessionFacade.StopSessionAsync(fs, teacher);
        }
    }
    async OnEndFudaoSessionEventAsync(evt) {
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            const fudaoSession = new FudaoDefinition_1.FudaoSession(evt.bodyTo());
            if (fudaoSession.Id === this.LastInvitedSessionId()) {
                // 結束作狀態清理
                await this.ResetSessionInvitingStatus();
                await this.publishEventAsync(evt, [IEventHub_1.EventReceiver.CLIENT]);
            }
            else if (fudaoSession.Id === this.DataSession.Id) {
                if (FudaoDefinition_1.StatusMethods.IsEnded(this.Status)) {
                    //已經正常斷線不用做事
                    this._logger.debug(`Fudao=${this.id} is ended already, no need to clean data session.`);
                    return;
                }
                //Data Session斷了代表連線斷了，本地端要中止輔導
                await this.InternalInterruptAsync(IEventHub_1.EventReceiver.Nobody);
            }
        }
    }
    async ExitFudaoSessionAsync(fudaoUser, fs) {
        if (!this.IsSessionBelongToThisFudao(fs))
            throw new FudaoError(`${fs} is not belong to here`);
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            await this._sessionFacade.ExitSessionAsync(fs, fudaoUser);
        }
    }
    async OnFailFudaoSessionEventAsync(evt) {
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            const body = evt.bodyTo();
            const fudaoSession = new FudaoDefinition_1.FudaoSession(body.Item2);
            if (fudaoSession.Id === this.LastInvitedSessionId()) {
                //不需特別處理只需轉送到外層
                await this.publishEventAsync(evt, [IEventHub_1.EventReceiver.CLIENT]);
            }
            else if (fudaoSession.Id === this.DataSession.Id) {
                //Data Session出FudaoSessionFailed不處理，等自行斷線
            }
        }
    }
    IsFudaoSupportedSession(st) {
        return st !== FudaoDefinition_1.FudaoSessionType.Unknown;
    }
    IsSessionBelongToThisFudao(fs) {
        return this.SessionIds.findIndex(sid => sid === fs.Id) > -1;
    }
    async AddSessionIsBelongToSelf(sessionId) {
        if (this.SessionIds.findIndex(sid => sid === sessionId) > -1) {
            this._logger.warn(`SessionId=${sessionId} is already belong to this fudao, something wrong?`);
            return;
        }
        this._sessionIds.push(sessionId);
        await this._fudaoRepo.SaveAsync(this);
    }
    async UpdatePassedTimeAsync(passedTime) {
        this._passedTimeMilliSecond += passedTime;
        const fudaoDuration = await this.CalculateTotalTimeAsync();
        if (this.PassedTimeMilliSecond >= fudaoDuration.asMilliseconds()) {
            // 輔導時間15分鐘
            this._fudaoTimeCounter.EndCount(this.id);
            //通知外層時間結束
            await this.publishEventAsync(FudaoEvent_1.FudaoEvent.FudaoTimeUpEvent(this.ToFudaoDto()), [IEventHub_1.EventReceiver.CLIENT]);
        }
        else {
            // 每秒都往外層送時間更新
            await this.publishEventAsync(FudaoEvent_1.FudaoEvent.TeacherTimePassedEvent(this.id, this.PassedTimeMilliSecond), [IEventHub_1.EventReceiver.CLIENT]);
            const SEND_PASSEDTIME_TO_STUDENT_INTERVAL = 60000; //一分鐘送給學生一次同步時間
            const timeSpan = this.PassedTimeMilliSecond - this._lastSendTimePassedEventTime;
            if (timeSpan >= SEND_PASSEDTIME_TO_STUDENT_INTERVAL) {
                await this.publishEventAsync(FudaoEvent_1.FudaoEvent.TeacherTimePassedEvent(this.id, this.PassedTimeMilliSecond), [new IEventHub_1.EventReceiver(this.Student.Id, this.Student.Name)]);
                this._lastSendTimePassedEventTime = this.PassedTimeMilliSecond;
            }
            const REPORT_TOS_SERVICE_INTERVAL = 180000; //三分鐘回報一次輔導服務
            const reportTimeSpan = this.PassedTimeMilliSecond - this._lastReportAliveTime;
            if (reportTimeSpan >= REPORT_TOS_SERVICE_INTERVAL) {
                await this.sendCommandAsync(FudaoCommand_1.FudaoCommand.TeacherReportFudaoIsAliveCommand(this.ToFudaoDto()));
                this._lastReportAliveTime = this.PassedTimeMilliSecond; //送成功才更新
            }
        }
    }
    async OnUpdateTimePassedAsync(evt) {
        if (this._isService)
            throw new FudaoError("Not Implemented.");
        else {
            //收到時間經過事件，表示事件不是在本地端發生的，只需更新資料。
            const receivedPassedTime = evt.bodyTo();
            this._passedTimeMilliSecond = receivedPassedTime;
            await this.publishEventAsync(FudaoEvent_1.FudaoEvent.TeacherTimePassedEvent(this.id, this.PassedTimeMilliSecond), [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    async CalculateTotalTimeAsync() {
        return this.CalculateTotalTime();
    }
    CalculateTotalTime() {
        return moment.duration(this.StandardDuration + (this.ExtendedTimes * this.ExtendDuration), "ms");
    }
    IsTimeUp() {
        const totalTime = this.CalculateTotalTime().asMilliseconds();
        return this.PassedTimeMilliSecond >= totalTime;
    }
    async BecomeStatus(becomingStatus) {
        this._status = becomingStatus;
        //狀態轉移統一處理內部資源
        switch (this.Status) {
            case FudaoDefinition_1.Status.Started:
                {
                    this._startTime = new Date();
                    this._lastSendTimePassedEventTime = 0;
                    this._fudaoTimeCounter.StartCount(this.id);
                }
                break;
            case FudaoDefinition_1.Status.Ended:
            case FudaoDefinition_1.Status.AbnormalEnded:
            case FudaoDefinition_1.Status.Interrupted:
                {
                    this._endTime = new Date();
                    //結束作資源清理
                    this._lastSendTimePassedEventTime = 0;
                    this._fudaoTimeCounter.EndCount(this.id);
                }
                break;
        }
        await this._fudaoRepo.SaveAsync(this);
    }
    async BecomeStartInvitingStatus(becomingStatus) {
        this._startInvitingStatus = becomingStatus;
        await this._fudaoRepo.SaveAsync(this);
    }
    async BecomeEndInvitingStatus(becomingStatus) {
        this._endInvitingStatus = becomingStatus;
        await this._fudaoRepo.SaveAsync(this);
    }
    async BecomeExtendInvitingStatus(becomingStatus) {
        this._extendInvitingStatus = becomingStatus;
        await this._fudaoRepo.SaveAsync(this);
    }
    async BecomeSessionInvitingStatus(fs, becomingStatus) {
        this._sessionInvitingStatus = new FudaoDefinition_1.FudaoSessionInvitingStatus(fs, becomingStatus);
        await this._fudaoRepo.SaveAsync(this);
    }
    async ResetSessionInvitingStatus() {
        this._sessionInvitingStatus = FudaoDefinition_1.FudaoSessionInvitingStatus.INVAID_FUDAO_INVITING_STATUS;
        await this._fudaoRepo.SaveAsync(this);
    }
    ToFudaoDto() {
        if (this === Fudao.INVALID_FUDAO)
            return FudaoDto_1.FudaoDto.INVALID_FUDAO_DTO;
        return new FudaoDto_1.FudaoDto({
            id: this.id,
            version: this.Version,
            teacher: this.Teacher,
            standardDuration: this.StandardDuration,
            extendDuration: this.ExtendDuration,
            student: this.Student,
            startTime: this.StartTime.getTime(),
            endTime: this.EndTime.getTime(),
            status: this.Status,
            chatId: this.ChatId,
            //sessionIds: this.SessionIds,
            dataSession: this.DataSession,
            extendedTimes: this.ExtendedTimes,
            passedTimeMilliSecond: this.PassedTimeMilliSecond,
        });
    }
}
Fudao.logger = LogManager_1.logManager.GetLogger("Fudao");
Fudao.CurrentVersion = FudaoDefinition_1.FudaoVersion;
Fudao.INVALID_FUDAO = new Fudao(false, NullCommandHub_1.NullCommandHubSingleton, NullEventHub_1.NullEventHubSingleton, NullFudaoRepository_1.NullFudaoRepositorySingleton, NullFudaoPassedTimeCounter_1.NullFudaoPassedTimeCounterSingleton, NullFudaoSessionFacade_1.NullFudaoSessionFacadeSingleton);
exports.Fudao = Fudao;
exports.FudaoErrorName = "FudaoError";
class FudaoError extends CommonBaseError_1.CommonBaseError {
}
exports.FudaoError = FudaoError;
//# sourceMappingURL=Fudao.js.map